const BASE = '/';
const CUSTOMER_GENERATE_QUOTATION = BASE + 'generate-quotation';
// const ADMIN = BASE + 'admin';
const HOME = BASE + 'home';
const ABOUT = BASE + 'about';
const LOGIN = BASE + 'login';
const SIGNUP = BASE + 'signup';
const SETTINGS = BASE + 'settings';
const PASSWORD_RESET = BASE + 'reset-password';
const RESUME_QUOTATION = BASE + 'resume-quotation' + '/:projectID';
const LEADS = BASE + 'leads';
const INSPIRATIONS = BASE + 'inspirations';
const PRODUCTS = BASE + 'products';
const ALL_CATEGORIES = PRODUCTS + '/all-categories';
const VARIANTS_GROUPING = PRODUCTS + '/variants-grouping';
const PARAMETRIC_VARIANTS = PRODUCTS + '/parametric-variants';
const ALL_PRODUCTS = PRODUCTS + '/all-products';
const ADD_PRODUCT = PRODUCTS + '/add-product';
const VIEW_PRODUCT = PRODUCTS + '/:itemId';
const UPDATE_PRODUCT = PRODUCTS + '/update-product/:itemId';
const LEAD_DETAILS = LEADS + '/:leadID/details';
const ADD_LEAD = LEADS + '/add';
const PROJECTS = BASE + 'projects';
const ORDERS = BASE + 'orders';
const ALL_PROJECTS = PROJECTS + '/all-projects';
const ALL_ORDERS = ORDERS + '/all-orders';
const ORDER_DETAILS = ORDERS + '/:projectID/order-details';
const HOLIDAYS = BASE + 'holidays';
const ADD_PROJECT = PROJECTS + '/add';
const ALL_INSPIRATIONS = INSPIRATIONS + '/all-inspirations';
const ALL_INSPIRATIONS_LEAD_FILTER = INSPIRATIONS + '/all-inspirations/lead/:leadID';
const ALL_INSPIRATIONS_PROJECT_FILTER = INSPIRATIONS + '/all-inspirations/project/:projectID';
const VIEW_INSPIRATION = INSPIRATIONS + '/:inspirationId';
const ALL_WARRANTY = PRODUCTS + '/all-warranty';
const DEFAULT_MODELS = PRODUCTS + '/default-models';
const ADD_WARRANTY = PRODUCTS + '/add-warranty';
const ADD_INSPIRATION = INSPIRATIONS + '/add-inspiration';
const LEAD_ADD_INSPIRATION = INSPIRATIONS + '/add-inspiration/lead/:leadID';
const PROJECT_ADD_INSPIRATION = INSPIRATIONS + '/add-inspiration/project/:projectID';
const QUOTATIONS = BASE + 'quotations';
const LEAD_QUOTATION = LEADS + '/:leadID' + PROJECTS + '/:projectID' + QUOTATIONS;
const GENERATE_CURRENT_QUOTATION = LEAD_QUOTATION + '/:quotationID';
const GENERATE_NEW_QUOTATION = GENERATE_CURRENT_QUOTATION + '/create-new-quotation';
const DASHBOARD = BASE + 'dashboard';

const QUOTATION_ESTIMATE = PROJECTS + '/:projectID' + QUOTATIONS + '/:quotationID' + '/estimate';
const NEW_PROJECT = BASE + 'new-project';
const TIMELINE = BASE + 'timeline/:projectID';
const PROJECT_DETAILS = PROJECTS + '/:projectID/project-details';
const PROJECT_LEDGER = PROJECTS + '/:projectID/project-ledger';
const PROJECT_ACTIVITY = PROJECTS + '/:projectID/project-activity';
const PROFILE = BASE + 'profile';
const MY_ORDERS = BASE + 'my-orders';
const DRAFTS = BASE + 'drafts';
const ORGANIZATION = BASE + 'organization';
const ORGANIZATION_SCHEDULER_MAPPING = ORGANIZATION + '/scheduler-mapping';
const APPROVAL = BASE + 'approval';
const APPROVAL_DELAY = APPROVAL + '/delay';
const APPROVAL_DOCUMENT = APPROVAL + '/document';
const APPROVAL_WARRANTY = APPROVAL + '/warranty';
const APPROVAL_DESCOPE = APPROVAL + '/descope';
const APPROVAL_PRODUCT_ITEM = APPROVAL + '/product-item';
const ALL_TICKETS = BASE + 'all-tickets';
const TICKET_CHAT = ALL_TICKETS + '/:ticketID/chat';

const COMMERCIALS = BASE + 'commercials';
const COMMERCIALS_PAYMENT = COMMERCIALS + '/payment';

const BUILDER_COSTING = BASE + 'builder-costing';

const PROMO_CODE = BASE + 'promo-code';

const INCENTIVES = BASE + 'incentives';

const FEEDBACK = BASE + 'feedback';
const EMAIL_CONFIG = BASE + 'email-config';
const ELECTRICAL_BASE = '/electrical';
const ELECTRICAL_PROJECT_DETAILS = ELECTRICAL_BASE + '/project/:projectID';
const ELECTRICAL_SITE_PHOTOS = ELECTRICAL_BASE + '/product/:itemId/photos';
const ELECTRICAL_PRODUCT_DETAILS = ELECTRICAL_BASE + '/product/:itemId';

const TECHNICIAN_BASE = '/technician';
const TECHNICIAN_CLAIM_DETAILS = TECHNICIAN_BASE + '/claim/:claimId';

const AppRoutes: any = {
	BASE,
	HOME,
	GENERATE_CURRENT_QUOTATION,
	ABOUT,
	LOGIN,
	SIGNUP,
	SETTINGS,
	PASSWORD_RESET,
	RESUME_QUOTATION,
	LEADS,
	ALL_INSPIRATIONS_LEAD_FILTER,
	INSPIRATIONS,
	PRODUCTS,
	ALL_CATEGORIES,
	VARIANTS_GROUPING,
	PARAMETRIC_VARIANTS,
	ALL_PRODUCTS,
	ADD_PRODUCT,
	UPDATE_PRODUCT,
	VIEW_PRODUCT,
	ADD_LEAD,
	PROJECTS,
	ADD_PROJECT,
	ALL_INSPIRATIONS_PROJECT_FILTER,
	DASHBOARD,

	//INSPIRATIONS
	ALL_INSPIRATIONS,
	VIEW_INSPIRATION,
	ADD_INSPIRATION,
	LEAD_ADD_INSPIRATION,
	PROJECT_ADD_INSPIRATION,

	//QUOTATIONS
	QUOTATIONS,

	LEAD_QUOTATION,
	CUSTOMER_GENERATE_QUOTATION,
	QUOTATION_ESTIMATE,
	GENERATE_NEW_QUOTATION,
	NEW_PROJECT,
	TIMELINE,

	BUILDER_COSTING,

	// WARRANTY,
	ALL_WARRANTY,
	ADD_WARRANTY,
	DEFAULT_MODELS,

	ORGANIZATION,
	ORGANIZATION_SCHEDULER_MAPPING,
	LEAD_DETAILS,
	PROJECT_DETAILS,
	PROJECT_LEDGER,
	PROFILE,
	MY_ORDERS,
	DRAFTS,
	ALL_PROJECTS,
	PROJECT_ACTIVITY,
	HOLIDAYS,
	APPROVAL,
	APPROVAL_DELAY,
	APPROVAL_DOCUMENT,
	APPROVAL_WARRANTY,
	APPROVAL_DESCOPE,
	APPROVAL_PRODUCT_ITEM,
	ORDERS,
	ALL_ORDERS,
	ORDER_DETAILS,

	// COMMERCIALS
	COMMERCIALS,
	COMMERCIALS_PAYMENT,

	// TICKETS
	ALL_TICKETS,
	TICKET_CHAT,

	// PROMO_CODE
	PROMO_CODE,

	//INCENTIVES
	INCENTIVES,

	// FEEDBACK
	FEEDBACK,

	// EMAIL CONFIG
	EMAIL_CONFIG,

	// ELECTRICIAN MODULE
	ELECTRICAL_BASE,
	ELECTRICAL_PROJECT_DETAILS,
	ELECTRICAL_SITE_PHOTOS,
	ELECTRICAL_PRODUCT_DETAILS,

	// TECHNICIAN (SERVICE TEAM MEMBER) MODULE
	TECHNICIAN_BASE,
	TECHNICIAN_CLAIM_DETAILS
};

export default AppRoutes;
